/**
 * Based on:
 *  - Smart Table Multi Sort <https://github.com/goodeggs/st-multi-sort>
 *  - orderBy Filter <https://github.com/goodeggs/orderby>
 *
 * Copyright (c) 2014 Good Eggs Inc.
 *
 * Licensed under the MIT license.
 */

/**
 * Based on `st-multi-sort/src/st_element_id.coffee`
 */
angular.module('smart-table').factory('stUniqueId', () => {
  let id = 0;
  return {
    generate: () => id++,
  };
});

/**
 * Based on `orderby/src/index.coffee`
 *
 * NOTE: This has been largely rewritten to handle expressions, filters, and nulls better.
 */
angular.module('smart-table').filter('customMultiOrderBy', [
  '$parse',
  function customMultiOrderBy($parse) {
    const compareProperty = function (predicate, reverse) {
      let getter = angular.identity;
      if (angular.isFunction(predicate)) {
        getter = predicate;
      } else if (angular.isString(predicate) && predicate !== '') {
        getter = $parse(predicate);
        if (getter.constant) {
          const key = getter();
          getter = (obj) => obj[key];
        }
      }

      const cmp = (a, b) => {
        let result = 0;
        const aVal = getter(a);
        const bVal = getter(b);

        if (aVal == null && bVal != null) {
          result = -1;
        } else if (aVal != null && bVal == null) {
          result = 1;
        } else if (angular.isString(aVal) && angular.isString(bVal)) {
          result = aVal.localeCompare(bVal);
        } else if (aVal > bVal) {
          result = 1;
        } else if (aVal < bVal) {
          result = -1;
        } else if (Number.isNaN(aVal) && !Number.isNaN(bVal)) {
          result = -1;
        } else if (!Number.isNaN(aVal) && Number.isNaN(bVal)) {
          result = -1;
        }
        return reverse ? -result : result;
      };
      return cmp;
    };

    return (collection, expressions) => {
      const predicates = expressions.map((expression) => {
        let predicate = expression;
        let reverse = false;
        if (angular.isObject(expression)) {
          predicate = expression.predicate;
          reverse = expression.reverse;
        }
        return compareProperty(predicate, reverse);
      });

      return collection.sort((a, b) => {
        for (let i = 0; i < predicates.length; i++) {
          const cmp = predicates[i];
          const value = cmp(a, b);
          if (value !== 0) {
            return value;
          }
        }
        return 0;
      });
    };
  },
]);

/**
 * Based on `st-multi-sort/src/index.coffee`
 */
angular.module('smart-table').directive('stMultiSort', [
  'stConfig',
  '$parse',
  '$rootScope',
  'stUniqueId',
  function stMultiSort(stConfig, $parse, $rootScope, stUniqueId) {
    return {
      restrict: 'A',
      require: '^stTable',
      link: (scope, element, attr, ctrl) => {
        let predicate = attr.stMultiSort;
        const getter = $parse(predicate);
        let index = 0;
        const classAscent = attr.stClassAscent || stConfig.sort.ascentClass;
        const classDescent = attr.stClassDescent || stConfig.sort.descentClass;
        const stateClasses = [classAscent, classDescent];
        let sortDefault = null;
        const elementId = stUniqueId.generate();

        /**
         * Use our custom orderBy filter, which supports reversing rows independently
         */
        ctrl.setSortFunction('customMultiOrderBy');

        /**
         * Sort the rows.
         * @param {Boolean} holdingShiftKey
         */
        const sort = (holdingShiftKey) => {
          index++;
          const tableState = ctrl.tableState();
          if (tableState.sort.predicate == null) {
            tableState.sort.predicate = [];
          } else if (!angular.isArray(tableState.sort.predicate)) {
            tableState.sort.predicate = [tableState.sort.predicate];
          }
          const reverse = index % 2 === 0;
          predicate = angular.isFunction(getter(scope)) ? getter(scope) : attr.stMultiSort;

          const indexOfExistingSort = tableState.sort.predicate.findIndex(
            (sortConfig) => sortConfig.elementId === elementId,
          );

          if (indexOfExistingSort !== -1) {
            tableState.sort.predicate.splice(indexOfExistingSort, 1);
          }

          index = index % 2 === 0 ? 2 : 1;
          element.removeClass(stateClasses[index % 2]).addClass(stateClasses[index - 1]);
          if (!holdingShiftKey) {
            $rootScope.$broadcast('clearOtherSortClasses', elementId);
          }

          if (!holdingShiftKey) {
            tableState.sort.predicate.length = 0;
          }
          tableState.sort.predicate.push({
            elementId,
            predicate,
            reverse: reverse === true,
          });

          tableState.pagination.start = 0;
          ctrl.pipe();
        };

        if (attr.stSortDefault) {
          sortDefault = scope.$eval(attr.stSortDefault) != null
            ? scope.$eval(attr.stSortDefault)
            : attr.stSortDefault;
        }

        if (sortDefault) {
          index = sortDefault === 'reverse' ? 1 : 0;
          sort();
        }

        element.bind('click', (e) => {
          if (!predicate) {
            return;
          }
          scope.$apply(() => sort(e.shiftKey || e.ctrlKey));
        });

        scope.$on('stPersistLoaded', () => {
          // Migrate tableState.sort.predicate to array if necessary
          const tableState = ctrl.tableState();
          if (tableState.sort.predicate == null) {
            tableState.sort.predicate = [];
          } else if (!angular.isArray(tableState.sort.predicate)) {
            tableState.sort.predicate = [tableState.sort.predicate];
          }
          // Check if this column is sorted on load and add class.
          const existingSort = tableState.sort.predicate.find(
            (sortConfig) => sortConfig.elementId === elementId,
          );
          if (existingSort == null) {
            element.removeClass(classAscent).removeClass(classDescent);
          } else if (!existingSort.reverse) {
            element.addClass(classAscent).removeClass(classDescent);
          } else if (existingSort.reverse) {
            element.removeClass(classAscent).addClass(classDescent);
          }
        });

        scope.$on('clearOtherSortClasses', (e, sortedElementId) => {
          if (sortedElementId !== elementId) {
            index = 0;
            element.removeClass(classAscent).removeClass(classDescent);
          }
        });
      },
    };
  },
]);
